import React, {useEffect, useState} from "react";
import {onChange} from "../../../config/Tools";
import {API, Config} from "../../../config/Config";
import {useAppData} from "../../../context/AppDataContext";
import {axiosInstance} from "../../../bricks/axios";
import Forms from "../../../bricks/form/Forms";

import "./CourseModalContent.css";

const CourseModalContent = ({courseId, onHide, updateCourse}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const {setError, setSuccess, selectedPeriod, period} = useAppData();
    const [levelList, setLevelList] = useState([]);

    useEffect(() => {
        const load = async () => {
            try {
                setIsLoading(true);
                const {method, url} = API.loadCourse(courseId);
                const {data} = await axiosInstance[method](url);
                setFormData(data);
            } catch (e) {
                setError(e);
            } finally {
                setIsLoading(false);
            }
        }

        if (courseId) {
            load();
        } else {
            setFormData({});
        }
    }, [courseId, setError]);

    useEffect(() => {
        const levelList = period.levelPointsConfig.reduce((acc, levelConfig) => {
            levelConfig.config.forEach(lvlCfg => {
                acc.push({label: `${levelConfig.name}: ${lvlCfg.level}`, value: lvlCfg._id});
            });
            return acc;
        }, []);
        setLevelList(levelList);
    }, []);

    const onSubmit = async (event) => {
        event.preventDefault();
        const data = {
            ...formData,
            period: selectedPeriod,
        };
        try {
            let response;
            if (formData._id) {
                const {method, url} = API.updateCourse(courseId);
                response = await axiosInstance[method](url, data);
                setSuccess("Kurz upraven");
                updateCourse('update', response.data);
            } else {
                const {method, url} = API.createCourse;
                response = await axiosInstance[method](url, data);
                setSuccess("Kurz vytvořen");
                updateCourse('add', response.data);
            }
            onHide();
        } catch (e) {
            setError(e);
        }
    }

    const daysOptions = [
        {label: 'Pondělí', value: 0},
        {label: 'Útery', value: 1},
        {label: 'Středa', value: 2},
        {label: 'Čtvrtek', value: 3},
        {label: 'Pátek', value: 4},
        {label: 'Sobota', value: 5},
        {label: 'Neděle', value: 6},
    ];

    const variantOptions = [
        {label: 'in-class', value: 'in-class'},
        {label: 'online', value: 'online'},
        {label: 'e-learning', value: 'elearning'}
    ]
    const typesOptions = Object.entries(Config.courseTypes).map(([key, type]) => ({label: type, value: key}));

    const handleDelete = async () => {
        if (window.confirm(`Opravdu chcete smazat kurz "${formData.code}"?`)) {
            try {
                const {method, url} = API.deleteCourseById(formData._id);
                await axiosInstance[method](url);
                setSuccess("Kurz smazán");
                updateCourse('delete', formData);
                onHide();
            } catch (e) {
                setError(e);
            }
        }
    }

    return (
        <>
            <form className="CourseModalContent" onSubmit={onSubmit}>
                <div className="modal-body">

                    <div className="row">
                        <div className="col-md-6">
                            <Forms.Text name="code" onChange={onChange(setFormData)} value={formData.code}/>
                        </div>
                        <div className="col-md-6">
                            <Forms.Text name="lector" onChange={onChange(setFormData)} value={formData.lector}/>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <Forms.Number name="capacity" onChange={onChange(setFormData)}
                                          value={formData.capacity || ''}/>
                        </div>
                        <div className="col-md-6">
                            <Forms.Checkboxes name="level" options={levelList} value={formData.level} label="Úroveň"
                                              onChange={onChange(setFormData)}/>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <Forms.Date name="endDate" onChange={onChange(setFormData)} value={formData.endDate || ''}/>
                        </div>
                        <div className="col-md-6">
                            <Forms.Date name="startDate" onChange={onChange(setFormData)}
                                        value={formData.startDate || ''}/>
                        </div>
                    </div>

                    <Forms.ArrayOf name="courseDateList" value={formData.courseDateList}
                                   onChange={onChange(setFormData)} label="Dny konání kurzu">
                        <Forms.Select name="day" options={daysOptions} disabled={isLoading}/>
                        <Forms.Time name="start" disabled={isLoading}/>
                        <Forms.Time name="end" disabled={isLoading}/>
                    </Forms.ArrayOf>


                    <div className="row">
                        <div className="col-md-6">
                            <Forms.Text name="note" onChange={onChange(setFormData)} value={formData.note}/>
                        </div>
                        <div className="col-md-6">
                            <Forms.Text name="place" onChange={onChange(setFormData)} value={formData.place}/>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <Forms.Text name="floorAndRoom" onChange={onChange(setFormData)}
                                        value={formData.floorAndRoom}/>
                        </div>
                        <div className="col-md-6">
                            <Forms.Checkboxes name="type" onChange={onChange(setFormData)} options={typesOptions}
                                              value={formData.type} label="Typ kurzu"/>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <Forms.Select name="variant" onChange={onChange(setFormData)} options={variantOptions}
                                          value={formData.variant} label="Varianta kurzu"/>
                        </div>
                        <div className="col-md-6">
                            <Forms.Number name="durationHours" onChange={onChange(setFormData)}
                                          label="Trvání kurzu v hodinách" value={formData.durationHours || ''}/>
                        </div>
                    </div>
                </div>

                <div className="modal-footer">
                    <div>
                        {formData._id &&
                            <Forms.Button onClick={handleDelete} label="Smazat kurz" disabled={isLoading}/>
                        }
                    </div>
                    <div>
                        <Forms.Button onClick={onHide} dark label="Zavřít" disabled={isLoading}/>
                        <Forms.Button type="submit" label={formData._id ? 'Uložit' : 'Vytvořit'}
                                      disabled={isLoading}/>
                    </div>
                </div>
            </form>
        </>
    )

}

export default CourseModalContent;